import { config } from '@iheartjane/config';

import { request } from '../lib/request';

const storeUrl = (storeId: string | number) =>
  `${config.apiPath}/stores/${storeId}`;

export class StoreSource {
  static get(id: string | number, params: any = {}) {
    return request(
      storeUrl(id),
      {
        method: 'GET',
      },
      params
    );
  }
}

export const getStoreSource = (id: string | number) => ({
  url: storeUrl(id),
  requireAuth: true,
});
